import React from 'react'
import { withTheme } from 'styled-components'
import TextField from '../@common/TextField'
import { IconDeviceMobile } from '@tabler/icons-react'

interface Props {
  theme: any
}

interface MobileProps {
  onBlur?: () => void
}

const MobileTelephone: React.FC<MobileProps> = ({ onBlur }) => (
  <TextField
    id='MobileNumber'
    onBlur={onBlur}
    type='tel'
    maxLength={12}
    name='mobile'
    placeholder='07…'
    icon={<IconDeviceMobile size={30} stroke={1.5} />}
  />
)

export default MobileTelephone
